import Vue from 'vue';

/**
 * Registra todas as telas de parametros
 */
Vue.component('FiltroParametrosMovimentosEmAbertoTest', () => import('../tesouraria/movimentosDeCaixa/MovimentosEmAbertoCaixaTest/FiltroParametrosMovimentosEmAberto'));
